import { render, staticRenderFns } from "./DocumentIcon.vue?vue&type=template&id=4292060a&scoped=true"
import script from "./DocumentIcon.vue?vue&type=script&lang=js"
export * from "./DocumentIcon.vue?vue&type=script&lang=js"
import style0 from "./DocumentIcon.vue?vue&type=style&index=0&id=4292060a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4292060a",
  null
  
)

export default component.exports